<template>
  <div class="full-h-section">
    <Transition name="fade">
      <div :key="currentStep.id">
        <component
            :key="currentStep.id"
            :is="`App${currentStep.component}`"
        />
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import AppMainTable from '@/components/MainTable'
import AppDirections from '@/components/Directions'
import AppIntro from '@/components/Intro'
import AppCongrats from '@/components/Congrats'

export default {
  name: "Content",
  components: {
    AppMainTable,
    AppDirections,
    AppIntro,
    AppCongrats
  },
  computed: {
    ...mapGetters({
      items: 'getDirectionsItems',
      currentStep: 'getCurrentStep'
    })
  },
  mounted() {
    window.dispatchEvent(new Event('resize'));
  }
}
</script>
